export default {
  methods: {
    render_line(data) {
      let xAxisData = []
      data = data.categorySaleList || []
      data.forEach((v,index) => {
        xAxisData.push((index+1)+'月')
      });
      data.sort((a,b)=>{
        return a.mouth - b.mouth
      })
      let option = {
          // title: {
          //     text: '各月销量走势',
          //     top: -5,
          //     left: 5,
          //     textStyle: {//主标题的属性
          //       // color: '#C28D21',//颜色
          //       // fontSize: 24,//大小
          //       // fontWeight:400,//
          //       fontFamily:'SourceHanSansCN',
          //       color:'#FFF',
          //       fontSize: '19px'
          //   },
          // },
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'cross',
                  crossStyle: {
                      color: '#999'
                  }
              }
          },
          grid: {
            left: 60,
            bottom: 30,
            right: 20
          },
          xAxis: [
              {
                  type: 'category',
                  data: xAxisData,
                  axisPointer: {
                      type: 'shadow'
                  },
                  axisTick: { show: false },
                  axisLabel: {
                    color: 'rgb(135,139,160)'
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#e2e2e2',
                      opacity: 0.5,
                      width: 2
                    }
                  },
              }
          ],
          yAxis: [
              {
                  type: 'value',
                  show: true,
                  // min: 10,
                  axisLabel: {
                    color: 'rgb(135,139,160)'
                  },
                  axisTick: { show: false },
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: '#e2e2e2',
                      opacity: 0.5,
                      width: 2
                    }
                  },
                  splitLine: { 
                    show: true,
                    interval: 'auto',
                    lineStyle:{
                      type:'dashed',//虚线
                      color: '#23BE72',
                      width: 1,
                      opacity: 0.3,
                      dashOffset: 20
                    },
                  },
                  minInterval: 1
              },
              // {
              //     type: 'value',
              //     // name: '单位：个',
              //     // axisLine: { show: true },
              //     // nameTextStyle: {
              //     //   color: '#999',
              //     //   height: 40,
              //     //   width: 80,
              //     //   lineHeight: 40,
              //     //   align: 'left',
              //     //   rich: {}
              //     // }
              // }
          ],
          series: [
              {
                  name: '',
                  type: 'line',
                  data: data.map(v=>v.saleNumTotal) || [],
                  itemStyle: {
                    color: 'rgb(11,183,142)',
                  },
                  label: {
                    show: true,
                    // formatter: param => {
                    //   return param.data + '个'
                    // },
                    color: '#FFF'
                  },
                  // symbol:'circle',
                  symbolSize: 10,
                //   lineStyle: {
                //     type: 'solid'
                //   },
                //   areaStyle: {
                //     color: {
                //       type: 'linear',
                //       colorStops: [{
                //               offset: 0,
                //               color: 'rgba(11, 183, 142, 0.4)' // 0% 处的颜色
                //           },
                //           {
                //               offset: 1,
                //               color: 'rgba(11, 183, 142, 0)' // 100% 处的颜色
                //           }
                //       ],
                //       global: false // 缺省为 false
                //   },
                // },
                areaStyle: {
                  opacity: 0.2
                },
                lineStyle: {
                  opacity: 0.8
                },
                  smooth: true
              }
          ]
      };
      let $instance = this.$echarts.init(this.$refs['line']);
      $instance.setOption(option);

      // $instance.on('click', params => {
      //   this.$router.push('/newProduct/newproduct-process')
      //   setTimeout(_=>{
      //     this.$bus.$emit('lineChartClicked', {
      //       name: params.name,
      //       type: 'sku'
      //     });
      //   },800)
    // });
      $instance.getZr().on('click',params => {
        if(this.menus[1].children[3].children.map(v=>v.name).includes("年度产品表现")) {
          this.$router.push({
            path: '/yearBehavior'
          })
      }
      });
    }
  }
}